import { ICustomerOption } from './../shared/shared';
import { removeZeroPositionCounts } from './uniqueCustomersHelpers';

export interface IChartOption extends ICustomerOption {
  customer: string;
}

type TSelectedChartResult = (chartId: number) => IChartOption;

function createOptions(filteredCharts: any[]): TSelectedChartResult {
  return (chartId: number): IChartOption => {
    function countPositions(acc: number, chart: any): number {
      return acc + chart.territoryData
        ? chart.territoryData.length
        : chart.supportedCountryIds.length;
    }

    function filterByChart(chart: any): boolean {
      return chart.chartId === chartId || chart.id === chartId;
    }

    const count = filteredCharts
      .filter(filterByChart)
      .reduce(countPositions, 0);

    const chart = filteredCharts.find(
      (chart: any) => chart.chartId === chartId || chart.id === chartId
    );

    return {
      label: chart?.chartDisplayName,
      value: chartId.toString(),
      positionsCount: count,
      customer:
        chart?.customerName === 'Billboard Charts'
          ? 'Billboard'
          : chart?.customerName,
    };
  };
}

interface IGetUniqueChartOptions {
  filteredCharts: any[] | null;
}
export const getUniqueChartOptions = ({
  filteredCharts,
}: IGetUniqueChartOptions): any[] | null => {
  if (filteredCharts) {
    const chartIds = filteredCharts.map(
      (chart: any) => chart.chartId || chart.id
    );
    const uniqueChartIds = new Set(chartIds);

    if (uniqueChartIds.size === 0) {
      return null;
    }

    return Array.from<any>(uniqueChartIds)
      .map(createOptions(filteredCharts))
      .filter(removeZeroPositionCounts)
      .sort((a: IChartOption, b: IChartOption) =>
        a.label.localeCompare(b.label)
      );
  }

  return null;
};
